import type { TransferRenewal as XpaTransferRenewal } from "@motain/xpa-proto-files-web/lib/types/transfer_kind_card";
import type { FC } from "react";
import { isNonNullable } from "@/types/isNonNullable";
import Link from "next/link";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";
import { trackingService } from "@/modules/analytics";
import { EntityLogo } from "@/components/entity-logo/EntityLogo";
import styles from "./TransferRenewal.module.scss";
import { isNullable } from "@/types/isNullable";
import classNames from "classnames";

type TransferRenewalProps = XpaTransferRenewal & {
  kind?: "rumor" | "completed";
};
export const TransferRenewal: FC<TransferRenewalProps> = (props) => {
  const { club, message, kind = "rumor" } = props;

  if (isNullable(club) || isNullable(club.clubLink)) {
    return null;
  }

  return (
    <Link
      className={classNames(
        "title-8-regular",
        styles.container,
        kind === "rumor" && styles.rumor,
        kind === "completed" && styles.completed,
      )}
      href={club.clubLink.urlPath}
      onClick={() => {
        if (isNonNullable(club.clubLink)) {
          trackingService.sendXpaTracking(
            club.clubLink.trackingEvents,
            EventType.EVENT_CLICK,
          );
        }
      }}
    >
      <div className={styles.clubGrid}>
        {isNonNullable(club.logo) && (
          <EntityLogo
            className={styles.logo}
            src={club.logo.path}
            darkModeSrc={club.logo.darkModePath}
            isPreloaded={club.logo.isPreloaded}
            size={20}
            alt={club.logo.alt}
          ></EntityLogo>
        )}

        <span className={styles.clubName}>{club.clubLink.name}</span>
      </div>

      <span className={styles.dot}>&middot;</span>
      <span className={styles.message}>{message}</span>
    </Link>
  );
};
